module.exports = __webpack_public_path__ + "static/ses-2021-governance-0902a09d2172a7baa8e56f5700e76738.pdf";